import { cva } from 'class-variance-authority';

export const wrapperClasses = cva(
  [
    'rounded-lg-alt bg-white-50 border-charcoal-alpha-50 flex h-14 w-full cursor-text flex-row items-center gap-2 border border-solid px-4 [&>*]:cursor-text'
  ],
  {
    variants: {
      disabled: {
        true: ['cursor-not-allowed opacity-50 [&>*]:cursor-not-allowed'],
        false: ['cursor-text']
      },
      validationStatus: {
        undefined: ['border-charcoal-alpha-50'],
        true: ['border-success-900'],
        false: ['border-danger-500']
      }
    },
    defaultVariants: {
      validationStatus: 'undefined'
    }
  }
);

export const contentClasses = cva(['relative flex h-full w-full flex-row overflow-hidden']);

export const prefixClasses = cva(
  ['bg-white-50 text-charcoal-500 flex h-full items-center justify-center transition-all'],
  {
    variants: {
      isFocused: {
        true: ['pt-4 opacity-100'],
        false: ['pt-0 opacity-100']
      }
    }
  }
);

export const labelClasses = cva(['leading-xl absolute transition-all'], {
  variants: {
    isFocused: {
      true: ['top-[2px] text-[11px] font-normal text-[#0F0F0F]'],
      false: ['top-3-5 text-[14px] leading-none text-[#737373]']
    }
  }
});

export const inputClasses = cva(
  [
    'peer bg-white-50 text-charcoal-500 text-medium h-full w-full truncate border-none border-solid text-[14px] tracking-[-0.3px] transition-all focus:outline-none',
    'placeholder:text-charcoal-[#0F0F0F] placeholder:text-normal'
  ],
  {
    variants: {
      variant: {
        default: [''],
        fluid: ['']
      },
      isFocused: {
        true: ['pt-4 placeholder:opacity-100'],
        false: ['pt-16 placeholder:opacity-0']
      }
    },
    defaultVariants: {
      variant: 'default'
    }
  }
);

export const statusIconClasses = cva(
  ['text-charcoal-500 flex h-full items-center justify-center transition-all'],
  {
    variants: {
      hasInputValue: {
        true: [''],
        false: ['']
      },
      isFocused: {
        true: ['pt-3 opacity-100'],
        false: ['pt-0 opacity-0']
      },
      status: {
        success: ['fill-success-900'],
        error: ['fill-danger-500']
      }
    }
  }
);

export const clearButtonClasses = cva(
  ['text-charcoal-500 flex items-center justify-center self-center transition-all'],
  {
    variants: {
      hasInputValue: {
        true: ['opacity-100'],
        false: ['opacity-0']
      },
      isFocused: {
        true: ['mt-3'],
        false: ['mt-0']
      }
    }
  }
);

export const suffixClasses = cva(
  ['bg-white-50 text-charcoal-500 flex h-full items-center justify-center transition-all'],
  {
    variants: {
      isFocused: {
        true: ['pt-4 opacity-100'],
        false: ['pt-0 opacity-0']
      }
    }
  }
);
